import React from "react";
import { Box, Button, PieCharts } from "codekit";

const NAME_TO_KEY = {
  "Al día": "verde",
  "En alerta": "ambar",
  "Crítico": "critico",
};

const CHART_COLORS = [
  { colorCellChart: "success-500", bgColorCards: "success-100", iconColor: "success-600", textColor: "success-600" },
  { colorCellChart: "warning-500", bgColorCards: "warning-100", iconColor: "warning-600", textColor: "warning-600" },
  { colorCellChart: "error-500", bgColorCards: "error-100", iconColor: "error-400", textColor: "error-500" },
];

/**
 * Donut chart del monitor de entrega urgente usando PieCharts de codekit
 * @author Oscar Rosero <oscar.rosero@repremundo.com.co>
 * @since 2026-05-01
 * @param {{ verde: number, ambar: number, critico: number }} kpis
 * @param {number} total
 * @param {function} onSegmentClick - recibe "verde"|"ambar"|"critico"
 * @param {function} onVerDetalle
 */
const Donutcht = ({ kpis, total, onSegmentClick, onVerDetalle }) => {
  const data = [
    { name: "Al día", value: kpis.verde, date: "< 15 días" },
    { name: "En alerta", value: kpis.ambar, date: "15 – 30 días" },
    { name: "Crítico", value: kpis.critico, date: "> 30 días" },
  ];

  const handleCellClick = ({ data: item }) => {
    onSegmentClick(NAME_TO_KEY[item.name]);
  };

  return (
    <Box border={1} rounded="lg" spacing={4} shadow>
      <Box mb={1} style={{ fontSize: 10, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: ".07em" }}>
        Distribución por antigüedad
      </Box>
      <Box mb={5} style={{ fontSize: 18, fontWeight: 700, color: "#1A1A2E" }}>
        DOs entrega urgente sin levante definitivo
      </Box>
      <PieCharts
        data={data}
        chartColors={CHART_COLORS}
        labelOne={String(total)}
        labelTwo="DOs activos"
        onClickCellChart={handleCellClick}
        onClickCard={handleCellClick}
        titleIcon="Ver detalle"
      />
      <Box mt={4}>
        <Button type="button" variant="secondary-light" size="l" onClick={onVerDetalle} style={{ width: "100%" }}>
          Ver detalle de operaciones
        </Button>
      </Box>
    </Box>
  );
};

export default Donutcht;
